// extracted by mini-css-extract-plugin
export default {"companyContainer":"AO-z","companyImage":"BO-z","container":"CO-z","heading":"DO-z","darkText":"EO-z","smallHeading":"FO-z","darkBackground":"GO-z","whiteBackground":"HO-z"};